import { BadgeCheckIcon } from "@heroicons/react/solid";
import React from "react";
import { skills } from "../data";

export default function Skills() {
  return (
    <section id="skills" className="bg-purple-900 text-white">
      <div className="container px-5 py-16 mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold title-font text-white mb-4">
            Skills &amp; Technologies
          </h1>
          <p className="text-base leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto text-purple-200">
            With extensive experience in full-stack development, we
            specialize in crafting high-performance, scalable applications.
          </p>
        </div>
        <div className="flex flex-wrap justify-center lg:w-4/5 sm:mx-auto sm:mb-2 -mx-1">
          {skills.map((skill, index) => (
            <div key={index} className="p-2 sm:w-1/2 w-full md:w-1/3 lg:w-1/4">
              <div className="bg-purple-800 border border-purple-700 rounded-xl flex p-4 h-full items-center">
                <BadgeCheckIcon className="text-purple-300 w-6 h-6 flex-shrink-0 mr-4" />
                <span className="title-font font-medium text-white">
                  {skill}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
